import { CircularProgress, TextField } from "@mui/material";
import React, { FormEvent, RefObject, useState } from "react";
import { Send, AttachFile } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import {
  AttachButton,
  Container,
  InputWrapper,
  SendButton,
} from "@components/ChatAgent/components/ChatAgentMessageInput/style";

interface ChatAgentMessageInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
  inputRef: RefObject<HTMLInputElement>;
  showAttachButton?: boolean;
}

const ChatAgentMessageInput = ({
  onSendMessage,
  disabled,
  isLoading,
  inputRef,
  showAttachButton = false,
}: ChatAgentMessageInputProps) => {
  const [message, setMessage] = useState("");
  const { t } = useTranslation("agent_chat");

  const sendMessage = (e?: FormEvent<HTMLFormElement>) => {
    if (e) e.preventDefault();
    if (!message) return;
    setMessage("");
    onSendMessage(message);
    if (inputRef.current) inputRef.current.focus();
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.altKey && !e.shiftKey) {
      sendMessage();
      e.preventDefault();
    }
  };

  return (
    <Container>
      {showAttachButton && (
        <AttachButton disabled={disabled}>
          <AttachFile />
        </AttachButton>
      )}
      <InputWrapper>
        <form onSubmit={sendMessage} style={{ width: "100%" }}>
          <TextField
            autoFocus={true}
            disabled={disabled}
            inputRef={inputRef}
            variant={"standard"}
            placeholder={t("input_ph") || ""}
            size={"small"}
            value={message}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                color: "#000000",
                fontSize: "14px",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#888888",
                opacity: 1,
              },
            }}
            multiline={true}
            maxRows={2}
            onKeyDown={(event) => handleInputKeyDown(event)}
            onChange={(event) => setMessage(event.target.value)}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </form>
      </InputWrapper>
      <SendButton
        onClick={() => sendMessage()}
        disabled={!message || disabled || isLoading}
        variant="contained"
        endIcon={
          isLoading ? (
            <CircularProgress size={16} sx={{ color: "#ffffff" }} />
          ) : (
            <Send sx={{ fontSize: "16px !important" }} />
          )
        }
      >
        {t("send_btn")}
      </SendButton>
    </Container>
  );
};

export default ChatAgentMessageInput;
